import { type ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';
import { DetailsSectionWrapper, ViewList } from 'app/main/components/page-layouts';

import ItemsListItem from '../ItemsListItem';
import ItemsMerchandiseTab from './tabs/ItemsMerchandiseTab';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => (
			<DetailsSectionWrapper disablePadding>
				<ViewList {...props} itemLayout={ItemsListItem} />
			</DetailsSectionWrapper>
		)
	},
	{
		id: 'merchpoints',
		title: 'TAB_ITEMS_MERCHPOINTS',
		content: ({ refresh, updateRefresh }) => <ItemsMerchandiseTab refresh={refresh} updateRefresh={updateRefresh} />
	}
];

export default tabs;
